function normalizePlacementForCompare(placement) {
  if (!placement || !placement.activityId) return null;
  return {
    activityId: String(placement.activityId),
    x: Number(placement.x) || 0,
    y: Number(placement.y) || 0,
    width: Number(placement.width) || 0,
    height: Number(placement.height) || 0,
    zIndex: Number(placement.zIndex) || 0,
    manualSize: Boolean(placement.manualSize),
    frameId: placement.frameId == null ? null : String(placement.frameId),
    placementSource: String(placement.placementSource || ''),
    pinCase: String(placement.pinCase || ''),
  };
}

function placementsEqual(a, b) {
  const left = normalizePlacementForCompare(a);
  const right = normalizePlacementForCompare(b);
  if (!left || !right) return false;
  return JSON.stringify(left) === JSON.stringify(right);
}

/**
 * Build placement delta ops from previous->next placement lists.
 */
export function buildPlacementOps(previousPlacements = [], nextPlacements = []) {
  const prevMap = new Map(
    (Array.isArray(previousPlacements) ? previousPlacements : [])
      .filter(item => item?.activityId != null)
      .map(item => [String(item.activityId), item])
  );
  const nextMap = new Map(
    (Array.isArray(nextPlacements) ? nextPlacements : [])
      .filter(item => item?.activityId != null)
      .map(item => [String(item.activityId), item])
  );

  const ops = [];
  for (const [activityId, next] of nextMap.entries()) {
    const prev = prevMap.get(activityId);
    if (prev && placementsEqual(prev, next)) continue;
    ops.push({ kind: 'upsert', activityId, placement: next });
  }
  for (const activityId of prevMap.keys()) {
    if (nextMap.has(activityId)) continue;
    ops.push({ kind: 'remove', activityId });
  }
  return ops;
}
